import axios from 'axios';

import { headers, STOCK } from '../../config';

function create(data) {
    return axios.post(`${STOCK}/items/${data.item_id}/accounts/${data.account_id}`, data, { headers: {
        ...headers(),
        "X-Request-ID": data.idempotentKey
    } })
    
}

// function create(data) {
//     console.log(data)
//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve({
//                 data :{
//                     item: {
//                         id: 1,
//                         display_name: "Tire"
//                     },
//                     account_type: {
//                         id: 1,
//                         name: "sales revenue"
//                     },
//                     account: {
//                         id: 1,
//                         display_name: "Current Assets",
//                     }, 
//                 }
//             })
//         }, 300)
//     })
// }

function findByID({itemId, accountId}) {
    return axios.get(`${STOCK}/items/${itemId}/accounts/${accountId}`, { headers: headers() })

    // console.log(id)
    // return new Promise((resolve) => {
    //     setTimeout(() => {
    //         resolve({
    //             data:{
    //                 item: {
    //                     id: 1,
    //                     name: "Petromine"
    //                 },
    //                 item_account_type: {
    //                     id: 1,
    //                     name: "sales revenue"
    //                 },
    //                 account: {
    //                     id: 1,
    //                     display_name: "11-Current Assets"
    //                 }
    //             }
    //         })
    //     })
    // })
}
function update(data) {
    return axios.put(`${STOCK}/items/${data.item_id}/accounts/${data.account_id}`, data, { headers: headers() })

    // console.log(data)
    // return new Promise((resolve) => {
    //     setTimeout(() => {
    //         resolve({
    //             data: {
    //                 item_id: 1
    //             }
    //         })
    //     })
    // })
}
function remove({itemId, accountId}) {
    return axios.delete(`${STOCK}/items/${itemId}/accounts/${accountId}`, { headers: headers() })
    // console.log(data)
    // return new Promise((resolve) => {
    //     setTimeout(() => {
    //         resolve({
    //             data: {
    //                 item_id: 1
    //             }
    //         })
    //     }, 300)
    // })
}
export default {
    create,
    findByID,
    update,
    remove
}